/**
 * Customer Care Page - Smooth Anchor Scrolling
 * Handles smooth scrolling to #policies and #faq anchors
 */

(function () {
  "use strict";

  /**
   * Smooth scroll to element with offset for fixed header
   * @param {string} targetId - The ID of the target element
   */
  function smoothScrollToAnchor(targetId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement) return;

    // Get header height for offset calculation
    const header = document.querySelector(".header");
    const headerHeight = header ? header.offsetHeight : 0;
    const additionalOffset = 20; // Extra padding

    // Calculate position
    const elementPosition = targetElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerHeight - additionalOffset;

    // Smooth scroll to position
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }

  /**
   * Handle hash on page load
   */
  function handleInitialHash() {
    const hash = window.location.hash;
    const validHashes = ["#policies", "#shipping", "#returns", "#faq"];

    if (validHashes.includes(hash)) {
      // Remove the # symbol
      const targetId = hash.substring(1);

      // Wait for page to fully load before scrolling
      setTimeout(() => {
        smoothScrollToAnchor(targetId);
      }, 100);
    }
  }

  /**
   * Handle anchor link clicks
   */
  function handleAnchorClicks() {
    // Get all links that point to customer care anchors
    const anchorLinks = document.querySelectorAll(
      'a[href*="#policies"], a[href*="#shipping"], a[href*="#returns"], a[href*="#faq"]',
    );

    anchorLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        const href = this.getAttribute("href");
        const validAnchors = ["#policies", "#shipping", "#returns", "#faq"];

        // Check if link contains valid customer care anchors
        const hasValidAnchor = validAnchors.some((anchor) => href.includes(anchor));

        if (hasValidAnchor) {
          // Extract the hash
          const hash = href.substring(href.indexOf("#"));
          const targetId = hash.substring(1);

          // Check if we're on the customer care page
          const isOnCustomerCarePage = window.location.pathname.includes("customer-care");

          if (isOnCustomerCarePage) {
            // Prevent default and smooth scroll
            e.preventDefault();
            smoothScrollToAnchor(targetId);

            // Update URL hash without jumping
            history.pushState(null, null, hash);
          }
          // If not on customer care page, let the link navigate normally
        }
      });
    });
  }

  /**
   * Handle browser back/forward navigation
   */
  function handleHashChange() {
    window.addEventListener("hashchange", function () {
      const hash = window.location.hash;
      const validHashes = ["#policies", "#shipping", "#returns", "#faq"];

      if (validHashes.includes(hash)) {
        const targetId = hash.substring(1);
        smoothScrollToAnchor(targetId);
      }
    });
  }

  /**
   * Initialize all anchor scrolling functionality
   */
  function init() {
    // Only run on customer care page
    const isCustomerCarePage = window.location.pathname.includes("customer-care");

    if (isCustomerCarePage) {
      // Handle hash on page load
      handleInitialHash();

      // Handle hash changes (back/forward browser navigation)
      handleHashChange();
    }

    // Handle anchor link clicks (works on any page)
    handleAnchorClicks();
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
